import { create } from 'zustand';

const useReportsStore = create((set) => ({
  // NB: the single-report reader (ReportViewModel) now renders inline on
  // /reports/:id via SingleReportPage — there is no view MODAL. The old
  // showReportViewModal flag was never set true, so it (and its dead modal
  // branch) were removed with plan 13.
  showReportCreateModal: false,
  setShowReportCreateModal: (value) => set({ showReportCreateModal: value }),

  // See suppliersStore.closeAllModals — same module-global lifetime problem,
  // same contract: navigation shuts every modal this store gates.
  closeAllModals: () => set({ showReportCreateModal: false }),
}));

export default useReportsStore;
